/**
 * MeteoTab — Pestaña "Meteo" dentro del expediente.
 *
 * Pre-rellena la dirección del riesgo (cuando exista) y la fecha del siniestro.
 * Al generar el PDF, se adjunta automáticamente al expediente como
 * "Evidencia meteo" (carpeta) y se registra en el tracking de actividad.
 */
import { useMemo } from "react";
import MeteoPanel from "@/components/meteo/MeteoPanel";

export default function MeteoTab({ exp }) {
  const defaultAddress = useMemo(() => {
    if (!exp) return "";
    // Prioridad: dirección del riesgo > dirección del asegurado.
    const r = exp.riesgo || {};
    const a = exp.asegurado || {};
    const partsRiesgo = [r.direccion, r.cp, r.localidad, r.provincia].filter(Boolean);
    if (partsRiesgo.length >= 2) return partsRiesgo.join(", ");
    const partsAseg = [a.direccion, a.cp, a.localidad, a.provincia].filter(Boolean);
    return partsAseg.join(", ");
  }, [exp]);

  const defaultDate = useMemo(() => {
    if (!exp) return "";
    // Fecha del siniestro (campo `fecha_ocurrencia` o `fecha_siniestro`).
    const f = exp.fecha_ocurrencia || exp.fecha_siniestro || "";
    if (!f) return "";
    // Aceptamos ISO o YYYY-MM-DD.
    return f.length >= 10 ? f.slice(0, 10) : "";
  }, [exp]);

  return (
    <div className="space-y-4" data-testid="meteo-tab">
      <MeteoPanel
        expedienteId={exp?.id}
        defaultAddress={defaultAddress}
        defaultDate={defaultDate}
      />
    </div>
  );
}
